import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "percent-top"
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": !_vm.isInactive
    }
  }, [_c('a-result', {
    attrs: {
      "status": "error"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('span', {
          staticClass: "customer-status"
        }, [_vm._v(_vm._s(_vm.t('停用')))])];
      },
      proxy: true
    }, {
      key: "title",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.t('你的帐户：{0} 已停用', [_vm.userInfo.login_account])) + " ")];
      },
      proxy: true
    }, {
      key: "subTitle",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.t('已停用的账号不支持查看及操作所有页面功能，如有疑问请联系您的客户经理。')) + " ")];
      },
      proxy: true
    }, {
      key: "extra",
      fn: function () {
        return [_c('a-button', {
          attrs: {
            "type": "primary",
            "disabled": _vm.logoutLoading,
            "data-permission": "customer_inactive_sign_off",
            "id": "customer_inactive_sign_off",
            "fbu-analyse-name": $t("\u6CE8\u9500\u8D26\u53F7")
          },
          on: {
            "click": _vm.handleSignOff
          }
        }, [_vm._v(_vm._s(_vm.t('注销账号')))]), _c('a-button', {
          attrs: {
            "disabled": _vm.logoutLoading,
            "data-permission": "customer_inactive_logout",
            "id": "customer_inactive_logout",
            "fbu-analyse-name": $t("\u9000\u51FA\u767B\u5F55")
          },
          on: {
            "click": _vm.handleLogout
          }
        }, [_vm._v(_vm._s(_vm.t('退出登录')))])];
      },
      proxy: true
    }])
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };